var allCompanyLists = function () {

    function pageBodyLoad() {
        checkUserStatus();
        setScrollEvent();
        setResizeEvent();
    }

    function setScrollEvent() {
        document.addEventListener("scroll", function () {
            configureSectionNavigation();
        }, false);
    }

    function setResizeEvent() {
        window.addEventListener("resize", function () {
            configureSectionNavigation();
        }, false);
    }

    function configureSectionNavigation() {
        setActiveSection();
        //positionSectionNavigation();
    }

    function setActiveSection() {
        let sections, activeSection, activeSectionElement;
        sections = document.querySelectorAll(".listsSection[data-section]");
        if (sections) {
            // Filter to discount elements beyond the top third of the screen, sort by closest position to top of screen. Take the top results section
            activeSection = Array.from(sections).filter(el => el.getBoundingClientRect().top < window.innerHeight * 0.3).sort((a, b) => { if (Math.abs(a.getBoundingClientRect().top) > Math.abs(b.getBoundingClientRect().top)) { return 1; } else if (Math.abs(a.getBoundingClientRect().top) < Math.abs(b.getBoundingClientRect().top)) { return -1; } else { return 0; }}).map(el => el.dataset.section)[0];
            if (activeSectionElement = document.querySelector(".sectionActive")) {
                activeSectionElement.classList.remove("sectionActive"); // Remove class from existing
            }
            if (activeSection) {
                document.querySelector(`.sectionElement[data-section='${activeSection}']`).classList.add("sectionActive");
            } else if (document.getElementById("sectionsList").firstChild) {
                document.getElementById("sectionsList").firstChild.classList.add("sectionActive");
            }
        }
    }

    function positionSectionNavigation() {
        let sectionHolder, existingListsSectionBounds, pageHeaderBounds;
        sectionHolder = document.getElementById("sectionHolder");
        existingListsSectionBounds = document.getElementById("existingListsSection").getBoundingClientRect();
        pageHeaderBounds = document.getElementById("pageHeader").getBoundingClientRect();
        sectionHolder.style.left = `${existingListsSectionBounds.left - Number(getComputedStyle(sectionHolder).width.replace("px", ""))}px`;
        sectionHolder.style.top = `${pageHeaderBounds.bottom}px`;

    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            companyLists.getRecentCompanyLists();
        }
        //
        else {
            requireLogin();
        }
    }

    function scrollToSection(element) {
        document.querySelector(`.listsSection[data-section='${element.dataset.section}']`).scrollIntoView({behavior: "smooth", block: "start"});
    }

    class ExploreLists {
        constructor() {
            this.exploreLists = [];
            this.folders = new ExploreFolders();
        }

        getRecentExploreLists() {
            let method, url;
            const exploreListsObject = this;

            method = "POST";
            url = "../api/lists/lists_actions.php?action=recentexplorelists";

            const getExploreListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.exploreLists.forEach(list => exploreListsObject.newExploreList(list.listID, list.listName, list.notes, list.listCreated, list.listEdited));
                    exploreListsObject.addListElementsToPage().loadComplete();
                }
                exploreListsObject.folders.getFolders();
            }

            const getExploreListsError = function () {
                console.log("Error obtaining explore lists");
                exploreListsObject.loadComplete();
            }

            coreFunctions.xhrHelper(method, url, getExploreListsSuccess, getExploreListsError);
        }
        newExploreList(listID, name, notes, created, edited) {
            const exploreList = new ExploreList(listID, name, notes, created, edited);
            this.exploreLists.push(exploreList);
            return exploreList;
        }

        addListElementsToPage() {
            if (this.exploreLists.length > 0) {
                this.exploreLists.forEach(list => list.addListElementToPage());
            } else {
                this.noExploreLists();
            }
            return this
        }

        noExploreLists() {
            // No saved lists
            document.getElementById("allExploreLists").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any saved Explore lists." }));
            return this;
        }

        loadComplete() {
            main.classList.remove("mainHidden");
            configureSectionNavigation();
            return this;
        }

        searchExploreLists(value) {
            let listSearchString, totalLists;

            listSearchString = value.toLowerCase();
            totalLists = this.exploreLists.length;

            for (var i = 0; i < totalLists; i++) {
                this.exploreLists[i].searchList(listSearchString);
            }

            // No lists pass the search criteria
            if (document.querySelector(".existingList:not(.hidden)") == undefined) {
                document.getElementById("listSearchNoResults").classList.remove("hidden");
            } else {
                document.getElementById("listSearchNoResults").classList.add("hidden");
            }
        }

        resetExploreLists() {
            this.exploreLists.forEach(list => list.displayListControls());
        }

        editExploreList(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("editExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = "../api/explore/explore_actions.php?action=edit";

            const editExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).editExploreListLoad(response);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const editExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editExploreListSuccess, editExploreListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditExploreListInputError() {
            document.querySelector("#editExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        editExploreListNotes(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("notesExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=notes`;

            const notesExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesExploreListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesExploreListForm textarea[name='notes']").value = response.notes;
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const notesExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesExploreListSuccess, notesExploreListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesExploreListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesExploreListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesExploreListInputError() {
            document.querySelector("#notesExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        copyExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=copy&listid=${form.elements.listID.value}`;

            const copyExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyExploreListLoad(response);
            }

            const copyExploreListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyExploreListSuccess, copyExploreListError, input);

        }

        copyExploreListLoad(response) {
            document.getElementById("copyExploreListButton").disabled = false;
            if (response.status == "success") {
                this.newExploreList(response.listID, response.listName, '', response.listCreated, response.listEdited).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        moveList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("moveExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=move_explore_list&listid=${form.elements.listID.value}`;

            const moveListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.exploreLists.find(list => list.listID == response.listID).moveListLoad(response);
                } else {
                    listsObject.moveListError(response);
                }
            }

            const moveListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not move list."
                };
                listsObject.moveListError(response);
            }

            coreFunctions.xhrHelper(method, url, moveListSuccess, moveListError, input);

        }

        moveListError(response) {
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        moveListControlAction() {
            document.querySelector("#exploreListMoveListForm input[name='listID']").value = this.listID;
            // See if the folders list is active
            if (document.getElementById("moveExploreListFolders").querySelector(`option[value='${this.folderID}']`)) {
                // Set to current value
                document.getElementById("moveExploreListFolders").value = this.folderID;
            }
            // Otherwise set to the default all value
            else {
                document.getElementById("moveExploreListFolders").value = "all";
            }
            // Add title and add to control box
            document.getElementById("exploreListToMoveTitle").innerHTML = this.name;
            coreFunctions.showOverlay("moveexplorelist");
        }

        moveListLoad(response) {
            this.folderID = response.folderID;
            document.getElementById("moveExploreListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=delete&listid=${form.elements.listID.value}`;

            const deleteExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteExploreListLoad(response);
            }

            const deleteExploreListError = function () {
                const response = {
                    status: "error",
                    "title": "Error",
                    "message": "Sorry, could not delete Explore list."
                }
                listsObject.deleteExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteExploreListSuccess, deleteExploreListError, input);
        }

        deleteExploreListLoad(response) {
            document.getElementById("deleteExploreListButton").disabled = false;

            if (response.status == "success") {
                this.exploreLists.find(list => list.listID == response.listID).deleteExploreListControlElementFromPage();
            }

            coreFunctions.hideOverlay(document.getElementById("deleteExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=share&listid=${form.elements.listID.value}`;

            const shareExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareExploreListLoad(response);
            }

            const shareExploreListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareExploreListSuccess, shareExploreListError, input);
        }

        // Clear input errors
        resetShareExploreListInputErrors() {
            document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        shareExploreListLoad(response) {
            let emailError, generalError;
            document.getElementById("shareExploreListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareExploreListButton"));
                showStatusMessage(response.title, response.message);
            } else {
                if (emailError = response.input_errors.email) {
                    document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = emailError;
                }
                if (generalError = response.input_errors.general) {
                    document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = generalError;
                }
            }
        }

    }

    class ExploreList {
        constructor(listID, name, notes, created, edited) {
            this.listID = listID;
            this.name = name;
            this.notes =  notes;
            this.created = created;
            this.edited = edited;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listBuiltWithCurrentVersion, listActionsControlLabel, moreDetailsControlHolder, accordianListElementMain;
            const listObject = this;

            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            accordianListElementMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }))

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/explore?list_id=${this.listID}`, innerHTML: `${this.name}${(copiedList) ? " <strong>*New</strong>" : ""}` }));

            existingList.appendChild(this.addListExtraDetails());

            actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, { change: function () { listObject.listActionsControlOnChange(this); } }));

            listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

            listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

            listActionsControlLabel.appendChild(this.createListActionsControls());

            if (copiedList) {
                document.getElementById("allExploreLists").insertBefore(existingList, document.getElementById("allExploreLists").firstElementChild)
            } else {
                document.getElementById("allExploreLists").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab
            if (activeActionTab = document.querySelector(`#allExploreLists input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", { innerHTML: "<span>Analyse</span>", class: "actionControl list-insights", title: "List insights", href: `${urlPath}/analyse?explorelist_id=${this.listID}` }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl list-notes", title: "Edit notes" }, { click: function () { listObject.updateEditNotesExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyExploreListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Move</span>", title: "Move list", class: "actionControl move-list" }, { click: function () { listObject.moveListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteExploreListButtonClick() } }));

            return actionsHolder;
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            if (this.edited) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));
            }

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

        searchList(listSearchString) {
            if (this.name.toLowerCase().includes(listSearchString)) {
                this.displayListControls();
            } else {
                this.hideListControls();
            }
        }

        displayListControls() {
            document.querySelector(`.existingList[list_id='${this.listID}']`).classList.remove("hidden");
        }

        hideListControls() {
            document.querySelector(`.existingList[list_id='${this.listID}']`).classList.add("hidden");
        }

        updateEditExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearEditExploreListInputError();
            document.querySelector("#editExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#editExploreListForm input[name='listName']").value = this.name;
            coreFunctions.showOverlay("editexplorelist");
        }

        updateEditNotesExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearNotesExploreListInputError();
            document.querySelector("#notesExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesExploreListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("notesexplorelist");
        }

        editExploreListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editExploreListSubmitButton").disabled = false;

            this.name = response.listName;
            // Update title on select page with new text
            document.querySelector(`.existingList[list_id='${this.listID}'] .existingListName`).innerHTML = this.name;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editExploreListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);

        }

        copyExploreListControlAction() {
            document.getElementById("exploreListToCopyTitle").innerHTML = this.name;
            document.querySelector("#copyExploreListForm input[name='listName']").value = `${this.name} copy`;
            document.querySelector("#copyExploreListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copyexplorelist");
        }

        moveListControlAction() {
            document.querySelector("#exploreListMoveListForm input[name='listID']").value = this.listID;
            // See if the folders list is active
            if (document.getElementById("moveExploreListButton").querySelector(`option[value='${this.folderID}']`)) {
                // Set to current value
                document.getElementById("moveExploreListButton").value = this.folderID;
            }
            // Otherwise set to the default all value
            else {
                document.getElementById("moveExploreListButton").value = "all";
            }
            // Add title and add to control box
            document.getElementById("exploreListToMoveTitle").innerHTML = this.name;
            coreFunctions.showOverlay("moveexplorelist");
        }

        moveListLoad(response) {
            this.folderID = response.folderID;
            document.getElementById("moveExploreListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteExploreListButtonClick() {
            document.getElementById("exploreListDeleteWarningTitle").innerHTML = `Confirm "${this.name}" deletion`;
            document.querySelector("#deleteExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteExploreListForm input[name='name']").value = this.name;
            coreFunctions.showOverlay("deleteexplorelistpanel");
        }

        deleteExploreListControlElementFromPage() {
            document.getElementById("allExploreLists").removeChild(document.querySelector(`#allExploreLists .existingList[list_id='${this.listID}']`));
            if (document.getElementById("allExploreLists").children.length == 0) {
                exploreLists.noExploreLists();
            }
        }

        shareListControlAction() {
            document.querySelector("#shareExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#shareExploreListForm input[name='listName']").value = this.name;
            exploreLists.resetShareExploreListInputErrors();
            coreFunctions.showOverlay("shareexplorelist");
        }
    }


    class CicLists {
        constructor() {
            this.cics = [];
        }

        // Create a new director and save it in the collection
        newCic(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            let cic = new Cic(title, subsectors, totalCompanies, revised, locked, created, code, description);
            this.cics.push(cic);
            return cic;
        }

        getAllCics() {
            let method, url;
            const cicsObject = this;

            method = "GET";
            url = "../api/rtics/rtics_actions.php?action=get_cics"

            const getCicsSuccess = function (response) {
                let getCicsResponse = JSON.parse(response);
                cicsObject.processCics(getCicsResponse);
                exploreLists.getRecentExploreLists();
            }

            const getCicsError = function (response) {

            }

            coreFunctions.xhrHelper(method, url, getCicsSuccess, getCicsError);
        }

        processCics(cics) {
            const allCics = this;
            if (cics.length > 0) {
                cics.forEach(cic => allCics.newCic(cic.title, null, cic.companies, cic.revised, cic.locked, cic.created, cic.code, cic.description).addCicVerticals(cic.verticals).addCicElementsToPage());
            } else {
                this.noCicsAvailable();
            }
        }

        noCicsAvailable() {
            document.getElementById("allCics").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any CICs." }));
            return this;
        }

    }

    class Cic {
        constructor(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            this.title = title;
            this.code = code;
            this.subsectors = subsectors;
            this.totalCompanies = totalCompanies;
            this.revised = revised;
            this.created = created;
            this.description = description;
            this.locked = locked;
            this.verticals = [];
        }

        addCicVerticals(verticals) {
            const cicObject = this;
            verticals.forEach(vertical => cicObject.newVertical(vertical.name, vertical.code, vertical.description, vertical.companies));
            return this;
        }

        newVertical(name, code, description, companies) {
            let newVertical = new CicVertical(name, code, description, companies, this.title, this.code, this.locked);
            this.verticals.push(newVertical);
            return newVertical;
        }

        addCicElementsToPage() {
            let cicList, actionsHolder, listDetailsElement, extraDetailsHolder, extraReleaseTag, moreDetailsControlHolder, accordianListElementMain, cicLink;
            const cicsObject = this;

            cicList = coreFunctions.createElementHelper("li", { class: "existingList", cic_name: this.title });

            accordianListElementMain = cicList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", {class: "actionControl extraDetailsButton", innerHTML: "&nbsp;"}, {click: function() {cicsObject.extraDetailsButtonClick(this);}})); // Show extra details button

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder  actionsHolder"}));

            // actionsHolder = cicList.appendChild(coreFunctions.createElementHelper("div", {class: "actionsHolder"}));

            // listDetailsElement = cicList.appendChild(coreFunctions.createElementHelper("div"), {class: "listDetailsElement"});

            // listDetailsElement.appendChild(coreFunctions.createElementHelper("button", {class: "actionControl extraDetailsButton", innerHTML: "&nbsp;"}, {click: function() {cicsObject.extraDetailsButtonClick(this);}})); // Show extra details button

            cicLink = listDetailsElement.appendChild(coreFunctions.createElementHelper("a", {title: "See full list", class:`existingListName${(this.locked) ? " cicLocked": ""}`, href: `${(this.locked) ? "": `${urlPath}/explore?rtic=${encodeURIComponent(this.code)}`}`, innerHTML: `<span>${this.title}</span>`}));

            if (extraReleaseTag = this.checkCicExtraReleaseTag()) {
                cicLink.appendChild(coreFunctions.createElementHelper("span", {class:"cicReleaseTag", innerHTML: extraReleaseTag}));
            }

            cicLink.appendChild(coreFunctions.createElementHelper("span", {class:"cicCompaniesTotal", innerHTML: `${this.totalCompanies.toLocaleString()} companies`}));

            if (this.locked === true) {
                listDetailsElement.appendChild(coreFunctions.createElementHelper("button", {class:"unlock", innerHTML: "subscribe to unlock"}, {click: function() {coreFunctions.showOverlay("subscribe")}}));
            }

            extraDetailsHolder = cicList.appendChild(coreFunctions.createElementHelper("ul", {class:"extraDetailsHolder accordian-list-details"}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Code</div><div class='field'>${this.code}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>`}));
            if (this.revised) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Revised</div><div class='field'>${moment(this.revised, "YYYY-MM-DD").format("DD/MM/YY")}</div>`}));
            }
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Companies</div><div class='field'>${this.totalCompanies.toLocaleString()}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Description</div><div class='field'>${(this.description) ? this.description : "Unavailable"}</div>`}));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Verticals</div>`})) // Verticals label
            this.verticals.forEach(vertical => extraDetailsHolder.appendChild(vertical.addCicVerticalElements()));

            //actionsHolder.appendChild(coreFunctions.createElementHelper("span", {class:"cicCompaniesTotal", innerHTML: `${this.totalCompanies.toLocaleString()} companies`}));

            // actionsHolder.appendChild(coreFunctions.createElementHelper("a", {innerHTML: "&nbsp;", title: "See RTIC analysis", class: "cic_analysis", href: `${urlPath}/analyse?rtic=${this.title}`}));

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", {innerHTML: "&nbsp;", title: "See CIC analysis", class: "rtic_analysis", href: `${urlPath}/analyse?rtic=${this.title}`}));

            document.getElementById("allCics").appendChild(cicList);
            return this;
        }

        checkCicExtraReleaseTag() {
            // Revised in the last month
            if (this.revised && moment().diff(moment(this.revised, "YYYY-MM-DD"), "months") == 0) {
                return "Revised";
            }
            // Created in the last month
            else if (moment().diff(moment(this.created, "YYYY-MM-DD"), "months") == 0) {
                return "New";
            } else {
                return false;
            }

        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

        cicSearch(searchString) {
            if (this.title.toLowerCase().includes(searchString)) {
                this.showCicListElement();
            } else {
                this.hideCicLiseElement();
            }
        }

        showCicListElement() {
            document.querySelector(`.existingList[cic_name='${this.title}']`).classList.remove("hidden");
        }

        hideCicLiseElement() {
            document.querySelector(`.existingList[cic_name='${this.title}']`).classList.add("hidden");
        }
    }

    class CicVertical {
        constructor (name, code, description, companies, sectorName, sectorCode, locked) {
            this.name = name;
            this.code = code;
            this.description = description;
            this.companies = companies;
            this.sectorName = sectorName;
            this.sectorCode = sectorCode;
            this.locked = locked;
        }

        addCicVerticalElements() {
            const cicVerticalsObject = this;
            let cicVerticalsHolder, cicVerticalDetailsElement, extraDetailsHolder;
            cicVerticalsHolder = coreFunctions.createElementHelper("li", { class: "existingList cicVerticalHolder accordian-list-tier-two" });

          //  cicVerticalDetailsElement = cicVerticalsHolder.appendChild(coreFunctions.createElementHelper("li"), {class: "listDetailsElement"});

            // Ascensor
            const accordianlistHolder = cicVerticalsHolder.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            accordianlistHolder.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder"})).appendChild(coreFunctions.createElementHelper("button", {class: "actionControl extraDetailsButton cicVerticalExtraDetailsButton", innerHTML: "&nbsp;"}, {click: function() {cicVerticalsObject.extraDetailsButtonClick(this)}})); // Show extra details button

            accordianlistHolder.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-name"})).appendChild(coreFunctions.createElementHelper("a", {title: "See full list", class:`existingListName${(this.locked) ? " cicLocked": ""}`, href: `${(this.locked) ? "": `${urlPath}/explore?rtic=${encodeURIComponent(this.sectorName)}`}&vertical=${encodeURIComponent(this.name)}`, innerHTML: `<span>${this.name}</span>`}));

            extraDetailsHolder = cicVerticalsHolder.appendChild(coreFunctions.createElementHelper("ul", {class:"extraDetailsHolder cicVerticalExtraDetailsHolder accordian-list-details"}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Code</div><div class='field'>${this.code}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Companies</div><div class='field'>${(this.companies) ? this.companies.toLocaleString() : "Unknown"}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Description</div><div class='field'>${(this.description) ? this.description : "Unavailable"}</div>`}));

            // TODO
            // if (this.locked === true) {
            //     listDetailsElement.appendChild(coreFunctions.createElementHelper("button", {class:"unlock", innerHTML: "subscribe to unlock"}, {click: function() {coreFunctions.showOverlay("subscribe")}}));
            // }

            return cicVerticalsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".cicVerticalHolder");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

    }


    class CompanyLists {
        constructor() {
            this.lists = [];
            this.folders = new Folders();
        }

        newCompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            const companyList = new CompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName);
            this.lists.push(companyList);
            return companyList;
        }

        getRecentCompanyLists() {
            let method, url;
            const companyListsObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_recent_ml_lists";
            const getRecentCompanyListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.companies_lists.forEach(list => companyListsObject.newCompanyList(list.list_id, list.title, list.notes, list.return_count, list.created, list.edited, list.folder_id, list.version, list.trainingCompanies.include.length, list.trainingCompanies.exclude.length, list.folder_name));
                }
                companyListsObject.addListElementsToPage();
                companyListsObject.folders.getFolders();
            }

            const getRecentCompanyListsError = function () {
                companyListsObject.folders.getFolders();
            }

            coreFunctions.xhrHelper(method, url, getRecentCompanyListsSuccess, getRecentCompanyListsError);
        }

        addListElementsToPage() {
            if (this.lists.length > 0) {
                this.lists.forEach(list => list.addListElementToPage());
            } else {
                // No saved lists
                document.getElementById("allMlLists").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any company lists." }));
            }
        }

        editList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("editListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=editlist&listid=${form.elements.listID.value}`;

            const editListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).editListLoad(response);
                } else {
                    listsObject.editListError(response);
                }
            }

            const editListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                listsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editListSuccess, editListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditListInputError() {
            document.querySelector("#editListForm .input_error").innerHTML = "&nbsp;";
        }

        editListNotes(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("notesListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=notes&listid=${form.elements.listID.value}`;

            const notesListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesListForm textarea[name='notes']").value = response.notes;
                    listsObject.lists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    listsObject.editListError(response);
                }
            }

            const notesListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                listsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesListSuccess, notesListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesListInputError() {
            document.querySelector("#notesListForm .input_error").innerHTML = "&nbsp;";
        }

        moveList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("moveListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=move_ml_list&listid=${form.elements.listID.value}`;

            const moveListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).moveListLoad(response);
                } else {
                    listsObject.moveListError(response);
                }
            }

            const moveListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not move list."
                };
                listsObject.moveListError(response);
            }

            coreFunctions.xhrHelper(method, url, moveListSuccess, moveListError, input);

        }

        moveListError(response) {
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=sharelist&listid=${form.elements.listID.value}`;

            const shareListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareListLoad(response);
            }

            const shareListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareListSuccess, shareListError, input);

        }

        shareListLoad(response) {
            document.getElementById("shareListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareListButton"));
                coreFunctions.showStatusMessage("Share success", `The "${response.list_title}" list has been shared with user ${response.share_email}`);
            }
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = response.input_errors.email;
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = response.input_errors.general;
        }

        resetShareListInputErrors() {
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        copyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=copy_ml_list&listid=${form.elements.listID.value}`;

            const copyListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyListLoad(response);
            }

            const copyListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyListSuccess, copyListError, input);

        }

        copyListLoad(response) {
            let copiedListDetails;
            document.getElementById("copyListButton").disabled = false;
            if (response.status == "success") {
                copiedListDetails = response.listDetails;
                this.newCompanyList(copiedListDetails.listID, copiedListDetails.title, '', copiedListDetails.returnCount, copiedListDetails.created, copiedListDetails.edited, copiedListDetails.folderID, copiedListDetails.version, copiedListDetails.trainingIncludeTotalCompanies, copiedListDetails.trainingExcludeTotalCompanies).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteCompanyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=delete_ml_list&listid=${form.elements.listID.value}`;

            const deleteListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteCompanyListLoad(response);
            }

            const deleteListError = function () {
                const response = {
                    status: "error",
                    title: "List delete error",
                    message: "Sorry, your list could not be deleted at this time."
                }
                listsObject.deleteCompanyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteListSuccess, deleteListError, input);
        }

        deleteCompanyListLoad(response) {
            document.getElementById("deleteListButton").disabled = false;
            if (response.status == "success") {
                this.lists.find(list => list.listID == response.listID).deleteListControlElementFromPage();
            }
            coreFunctions.hideOverlay(document.getElementById("deleteListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class CompanyList {
        constructor(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            this.listID = listID;
            this.title = title;
            this.notes = notes;
            this.returnCount = returnCount;
            this.created = created;
            this.edited = edited;
            this.folderID = folderID;
            this.version = version;
            this.currentProductVersion = "2.0";
            this.trainingIncludeTotalCompanies = trainingIncludeTotalCompanies;
            this.trainingExcludeTotalCompanies = trainingExcludeTotalCompanies;
            this.folderName = folderName;
        }

        checkListBuiltWithCurrentVersion() {
            return this.version == this.currentProductVersion;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listBuiltWithCurrentVersion, listActionsControlLabel, moreDetailsControlHolder, accordianListElementMain;
            const listObject = this;

            listBuiltWithCurrentVersion = this.checkListBuiltWithCurrentVersion();

            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            // Ascensor update
            accordianListElementMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }))

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/ml_list?list_id=${this.listID}${(listBuiltWithCurrentVersion) ? "" : "&legacylist=true"}`, innerHTML: `<span>${this.title}${(copiedList) ? " <strong>*New</strong>" : ""}${(listBuiltWithCurrentVersion) ? `<span class='formattedVersion'></span>` : ""}</span>` }));

            existingList.appendChild(this.addListExtraDetails());

            // Only add controls for lists made in the current version
            if (listBuiltWithCurrentVersion) {
                actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, {change: function() {listObject.listActionsControlOnChange(this);}}));

                listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

                listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

                listActionsControlLabel.appendChild(this.createListActionsControls());
            }

            if (copiedList) {
                document.getElementById("allMlLists").insertBefore(existingList, document.getElementById("allMlLists").firstElementChild)
            } else {
                document.getElementById("allMlLists").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab;
            if (activeActionTab = document.querySelector(`#allMlLists input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl list-notes", title: "Edit notes" }, { click: function () { listObject.updateNotesListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Move</span>", title: "Move list", class: "actionControl move-list" }, { click: function () { listObject.moveListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteCompanyListButtonClick() } }));

            return actionsHolder;
        }

        updateEditListOverlay() {
            // Hide previous input errors
            companyLists.clearEditListInputError();
            document.querySelector("#editListForm input[name='listID']").value = this.listID;
            document.querySelector("#editListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("editlist");
        }

        updateNotesListOverlay() {
            // Hide previous input errors
            companyLists.clearNotesListInputError();
            document.querySelector("#notesListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("noteslist");
        }

        editListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            this.title = response.listTitle;
            // Update title on select page with new text
            document.querySelector(`#allMlLists .existingList[list_id='${this.listID}'] .existingListName span`).innerHTML = this.title;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);

        }

        copyListControlAction() {
            document.getElementById("listToCopyTitle").innerHTML = this.title;
            document.querySelector("#copyListForm input[name='copyListTitle']").value = `${this.title} copy`;
            document.querySelector("#copyListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copylist");
        }

        moveListControlAction() {
            document.querySelector("#moveListForm input[name='listID']").value = this.listID;
            // See if the folders list is active
            if (document.getElementById("moveListFolders").querySelector(`option[value='${this.folderID}']`)) {
                // Set to current value
                document.getElementById("moveListFolders").value = this.folderID;
            }
            // Otherwise set to the default all value
            else {
                document.getElementById("moveListFolders").value = "all";
            }
            // Add title and add to control box
            document.getElementById("listToMoveTitle").innerHTML = this.title;
            coreFunctions.showOverlay("movelist");
        }

        moveListLoad(response) {
            this.folderID = response.folderID;
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareListControlAction() {
            document.querySelector("#shareListForm input[name='shareUserEmail']").value = null;
            document.querySelector("#shareListForm input[name='listID']").value = this.listID;
            companyLists.resetShareListInputErrors();

            // Add title and add to control box
            document.getElementById("listToShareTitle").innerHTML = this.title;
            coreFunctions.showOverlay("sharelist");
        }

        deleteCompanyListButtonClick() {
            document.getElementById("companyListDeleteWarningTitle").innerHTML = `Confirm "${this.title}" deletion`;
            document.querySelector("#deleteListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("deletelistpanel");
        }

        deleteListControlElementFromPage() {
            document.getElementById("allMlLists").removeChild(document.querySelector(`#allMlLists .existingList[list_id='${this.listID}']`));
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Training set</div><div class='field'>Include: <span class='green'>${this.trainingIncludeTotalCompanies}</span> | Exclude: <span class='orange'>${this.trainingExcludeTotalCompanies}</span></div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Folder</div><div class='field'><a class='folderLink' href='${(this.folderID) ? `${urlPath}/listsfolder?folder_id=${this.folderID}&folder_name=${this.folderName}` : `${urlPath}/listsfolder?folder_id=all`}' target='_blank'>${(this.folderName) ? this.folderName : "All company lists"}<a></div>` })); // Folder link

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }
    }

    class Folders {
        constructor() {
            this.folders = [];
        }

        getFolders() {
            let method, url;
            const foldersObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_ml_list_folders";

            const getFoldersSuccess = function (responseText) {
                const response = JSON.parse(responseText)
                if (response.status == "success") {
                    response.folders.forEach(folder => foldersObject.newFolder(folder.folder_id, folder.folder_name));
                    foldersObject.addFoldersToPage().addFoldersToDatalist();
                }
                //document.getElementById("main").classList.remove("mainHidden");
                cicLists.getAllCics();
            }

            const getFoldersError = function () {
                console.log("Error getting folders");
                // document.getElementById("main").classList.remove("mainHidden");
                cicLists.getAllCics();
            }

            coreFunctions.xhrHelper(method, url, getFoldersSuccess, getFoldersError);
        }

        mlListFoldersSearch(form) {
           const query = coreFunctions.escapeRegExp(form.elements["ml-folder-search"].value);
           const re = new RegExp(query, "i");
           console.log(re);
           const folderElements = document.querySelectorAll("#folderSelectHolder .folderSelectFlex:not([data-name='all-lists'])");
           folderElements.forEach(element => {
                if (element.hasAttribute("data-name") && element.dataset.name.match(re)) {
                    element.classList.add("search-match");
                    element.classList.remove("search-mismatch");
                } else {
                    element.classList.remove("search-match");
                    element.classList.add("search-mismatch");
                }
           });
        }

        resetMlListFoldersSearch() {
            document.querySelectorAll("#folderSelectHolder .folderSelectFlex").forEach(element => {
                element.classList.remove("search-mismatch");
                element.classList.remove("search-match");
            });
        }

        newFolder(folderID, name) {
            const folder = new Folder(folderID, name);
            this.folders.push(folder);
            return folder;
        }

        addFoldersToPage() {
            this.folders.forEach((folder, index) => folder.addFolderToPage(index).addFolderToMoveListSelect());
            return this;
        }

        addFoldersToDatalist() {
            this.folders.forEach(folder => document.getElementById("mlListFoldersDatalist").appendChild(folder.createFolderDatalistOption()));
            return this;
        }

        folderSubgroupToggleOnClick() {
            let folderSelectHolder = document.getElementById("folderSelectHolder");
            if (folderSelectHolder.classList.contains("folderSubgroupVisible")) {
                folderSelectHolder.classList.remove("folderSubgroupVisible");
            } else {
                folderSelectHolder.classList.add("folderSubgroupVisible");
            }
        }

        newFolderControlClick() {
            document.getElementById("newFolderTitle").value = null;
            coreFunctions.showOverlay("newfolder");
        }

        createNewFolder(form) {
            let input, method, url;
            const foldersObject = this;

            document.getElementById("newFolderSubmit").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = "../api/lists/lists_actions.php?action=new_ml_list_folder";

            const createNewFolderSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                foldersObject.newFolderLoad(response);
            }

            const createNewFolderError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not create new folder."
                }
                foldersObject.newFolderLoad(response);
            }

            coreFunctions.xhrHelper(method, url, createNewFolderSuccess, createNewFolderError, input);
        }

        newFolderLoad(response) {
            document.getElementById("newFolderSubmit").disabled = false;
            if (response.status == "success") {
                this.newFolder(response.folderID, response.folderName).addNewFolderToPage().addFolderToMoveListSelect().updateFolderOrdering();
            }
            coreFunctions.hideOverlay(document.getElementById("newFolderSubmit"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class Folder {
        constructor(folderID, name) {
            this.folderID = folderID;
            this.name = name;
            this.folderElementsInTopLevel = Infinity;
        }

        addFolderToPage(index) {
            let folderHolder = document.querySelector("#folderSelectHolder .topFolders");
            folderHolder.appendChild(this.createNewFolderControl());
            return this;
        }

        addNewFolderToPage() {
            let folderHolder = document.querySelector("#folderSelectHolder .topFolders");
            folderHolder.insertBefore(this.createNewFolderControl(), folderHolder.firstElementChild.nextSibling);
            return this;
        }

        addFolderToMoveListSelect() {
            document.getElementById("moveListFolders").appendChild(coreFunctions.createElementHelper("option", { value: this.folderID, innerHTML: this.name }));
            return this;
        }

        updateFolderOrdering() {
            let currentLastFolderElementInTopLevel, folderSubgroup;
            if (this.totalFolderElementsInTopLevel() > this.folderElementsInTopLevel) {
                folderSubgroup = document.getElementById("folderSubgroup");
                currentLastFolderElementInTopLevel = document.querySelector("#folderSelectHolder .topFolders").lastElementChild.previousSibling;
                folderSubgroup.insertBefore(currentLastFolderElementInTopLevel, folderSubgroup.firstElementChild);
                document.getElementById("folderSubgroup").classList.remove("hidden");
                document.getElementById("showAllFoldersHolder").classList.remove("hidden");
            }
            return this;
        }

        totalFolderElementsInTopLevel() {
            return document.querySelector("#folderSelectHolder .topFolders").children.length;
        }

        createNewFolderControl() {
            let folderSelectFlex, folderSelect, folderSelectButton;

            folderSelectFlex = coreFunctions.createElementHelper("div", { class: "folderSelectFlex", "data-name": this.name});

            folderSelect = folderSelectFlex.appendChild(coreFunctions.createElementHelper("div", { class: "folderSelect" }));

            folderSelectButton = folderSelect.appendChild(coreFunctions.createElementHelper("a", { href: `${urlPath}/listsfolder?folder_id=${this.folderID}&folder_name=${this.name}`, class: "folderSelectButton", innerHTML: `<span class='folderName'>${this.name}</span>` }))

            return folderSelectFlex;
        }

        createFolderDatalistOption() {
            const option = document.createElement("option");
            option.value = this.name;
            return option;
        }
    }

    class ExploreFolders {
        constructor() {
            this.folders = [];
        }

        getFolders() {
            let method, url;
            const foldersObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_explore_list_folders";

            const getExploreFoldersSuccess = function (responseText) {
                const response = JSON.parse(responseText)
                if (response.status == "success") {
                    response.folders.forEach(folder => foldersObject.newFolder(folder.folder_id, folder.folder_name));
                    foldersObject.addExploreFoldersToPage().addExploreFoldersToDatalist();
                }
            }

            const getExploreFoldersError = function () {
                console.log("Error getting folders");
                cicLists.getAllCics();
            }

            coreFunctions.xhrHelper(method, url, getExploreFoldersSuccess, getExploreFoldersError);
        }

        exploreListFoldersSearch(form) {
           const query = coreFunctions.escapeRegExp(form.elements["explore-folder-search"].value);
           const re = new RegExp(query, "i");
           const folderElements = document.querySelectorAll("#exploreFolderSelectHolder .folderSelectFlex:not([data-name='all-lists'])");
           folderElements.forEach(element => {
                if (element.hasAttribute("data-name") && element.dataset.name.match(re)) {
                    element.classList.add("search-match");
                    element.classList.remove("search-mismatch");
                } else {
                    element.classList.remove("search-match");
                    element.classList.add("search-mismatch");
                }
           });
        }

        resetExploreListFoldersSearch() {
            document.querySelectorAll("#exploreFolderSelectHolder .folderSelectFlex").forEach(element => {
                element.classList.remove("search-mismatch");
                element.classList.remove("search-match");
            });
        }

        newFolder(folderID, name) {
            const folder = new ExploreFolder(folderID, name);
            this.folders.push(folder);
            return folder;
        }

        addExploreFoldersToPage() {
            this.folders.forEach((folder, index) => folder.addFolderToPage(index).addFolderToMoveListSelect());
            return this;
        }

        addExploreFoldersToDatalist() {
            this.folders.forEach(folder => document.getElementById("exploreListFoldersDatalist").appendChild(folder.createFolderDatalistOption()));
            return this;
        }

        folderSubgroupToggleOnClick() {
            let folderSelectHolder = document.getElementById("exploreFolderSelectHolder");
            if (folderSelectHolder.classList.contains("folderSubgroupVisible")) {
                folderSelectHolder.classList.remove("folderSubgroupVisible");
            } else {
                folderSelectHolder.classList.add("folderSubgroupVisible");
            }
        }

        newFolderControlClick() {
            document.getElementById("newExploreListFolderTitle").value = null;
            coreFunctions.showOverlay("newexplorelistfolder");
        }

        createNewFolder(form) {
            let input, method, url;
            const foldersObject = this;

            document.getElementById("newExploreListFolderSubmit").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = "../api/lists/lists_actions.php?action=new_explore_list_folder";

            const createNewFolderSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                foldersObject.newFolderLoad(response);
            }

            const createNewFolderError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not create new folder."
                }
                foldersObject.newFolderLoad(response);
            }

            coreFunctions.xhrHelper(method, url, createNewFolderSuccess, createNewFolderError, input);
        }

        newFolderLoad(response) {
            document.getElementById("newExploreListFolderSubmit").disabled = false;
            if (response.status == "success") {
                this.newFolder(response.folderID, response.folderName).addNewFolderToPage().addFolderToMoveListSelect().updateFolderOrdering();
            }
            coreFunctions.hideOverlay(document.getElementById("newExploreListFolderSubmit"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class ExploreFolder {
        constructor(folderID, name) {
            this.folderID = folderID;
            this.name = name;
            this.folderElementsInTopLevel = Infinity;
        }

        addFolderToPage(index) {
            let folderHolder = document.querySelector("#exploreFolderSelectHolder .topFolders");
            folderHolder.appendChild(this.createNewFolderControl());
            return this;
        }

        addNewFolderToPage() {
            let folderHolder = document.querySelector("#exploreFolderSelectHolder .topFolders");
            folderHolder.insertBefore(this.createNewFolderControl(), folderHolder.firstElementChild.nextSibling);
            return this;
        }

        addFolderToMoveListSelect() {
            document.getElementById("moveExploreListFolders").appendChild(coreFunctions.createElementHelper("option", { value: this.folderID, innerHTML: this.name }));
            return this;
        }

        updateFolderOrdering() {
            let currentLastFolderElementInTopLevel, folderSubgroup;
            if (this.totalFolderElementsInTopLevel() > this.folderElementsInTopLevel) {
                folderSubgroup = document.getElementById("folderSubgroup");
                currentLastFolderElementInTopLevel = document.querySelector("#exploreFolderSelectHolder .topFolders").lastElementChild.previousSibling;
                folderSubgroup.insertBefore(currentLastFolderElementInTopLevel, folderSubgroup.firstElementChild);
                document.getElementById("folderSubgroup").classList.remove("hidden");
                document.getElementById("showAllFoldersHolder").classList.remove("hidden");
            }
            return this;
        }

        totalFolderElementsInTopLevel() {
            return document.querySelector("#exploreFolderSelectHolder .topFolders").children.length;
        }

        createNewFolderControl() {
            let folderSelectFlex, folderSelect, folderSelectButton;

            folderSelectFlex = coreFunctions.createElementHelper("div", { class: "folderSelectFlex", "data-name": this.name});

            folderSelect = folderSelectFlex.appendChild(coreFunctions.createElementHelper("div", { class: "folderSelect" }));

            folderSelectButton = folderSelect.appendChild(coreFunctions.createElementHelper("a", { href: `${urlPath}/explorelistsfolder?folder_id=${this.folderID}&folder_name=${this.name}`, class: "folderSelectButton", innerHTML: `<span class='folderName'>${this.name}</span>` }))

            return folderSelectFlex;
        }

        createFolderDatalistOption() {
            const option = document.createElement("option");
            option.value = this.name;
            return option;
        }
    }

    const companyLists = new CompanyLists();
    const exploreLists = new ExploreLists();
    const cicLists = new CicLists();

    return {
        pageBodyLoad: pageBodyLoad,
        scrollToSection: scrollToSection,
        companyLists: companyLists,
        exploreLists: exploreLists,
        cicLists: cicLists
    }

}();
